import {InfoCircleOutlined} from "@ant-design/icons";
import {Button, Card, Modal} from "antd";
import React, {useState} from "react";
import {useCodPaymentMethodSelection} from "../../../../../hooks/useCodPaymentMethodSelection";
import {DocumentModal} from "../../../../documents/documentModal";
import {CodAggrementSelectionModal} from "./CodAggrementSelectionModal";
export const CodAggrementBlock = ({codCommissionRate, isBackoffice = false}) => {
    const [recall, setRecall] = useState(false);
    const {
        subCompaniesResults,
        canCodPaymentMethodSelectionSubcompanies,
        canShowCodPaymentMethodSelection,
        alreadyHasCoDPaymentContractSubcompanies,
        generateCoDPaymentContract,
        getCoDPaymentContract,
        contractLoading
    } = useCodPaymentMethodSelection({
        initialCall: true,
        initialData: [],
        dependencies: [recall],
        isBackoffice: isBackoffice
    });

    const [open, setOpen] = useState(false);
    const [codContractModalVisibility, setCodContractModalVisibility] = useState(false);
    const [codContractUrl, setCodContractUrl] = useState("");

    const openCodContractModal = async () => {
        const subCompanyId = alreadyHasCoDPaymentContractSubcompanies?.[0]?._id;
        const contractResult = await getCoDPaymentContract({
            subCompanyId
        });
        if (contractResult?.success) {
            setCodContractUrl(
                contractResult?.uploadedDocumentPath || contractResult?.contractPath || ""
            );
            setCodContractModalVisibility(true);
        }
    };

    return (
        <>
            {canShowCodPaymentMethodSelection ? (
                <Card
                    style={{
                        display: "inline-block",
                        minWidth: 250,
                        minHeight: 100,
                        background: "#f6ffed",
                        border: "1px solid #b7eb8f",
                        cursor: "pointer",
                        verticalAlign: "middle",
                        paddingTop: 20
                    }}
                    bodyStyle={{
                        padding: 16,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        gap: 12,
                        fontWeight: 600
                    }}
                    onClick={() => setOpen(true)}
                >
                    Kapıda Ödeme Sözleşmesi Oluştur
                </Card>
            ) : (
                <Card
                    style={{
                        display: "inline-block",
                        minWidth: 250,
                        background: "#f6ffed",
                        border: "1px solid #b7eb8f"
                    }}
                    bodyStyle={{
                        padding: 16,
                        display: "flex",
                        alignItems: "center",
                        gap: 12
                    }}
                    extra={
                        alreadyHasCoDPaymentContractSubcompanies?.length > 0 ? (
                            <Button type="link" onClick={openCodContractModal}>
                                Sözleşmeyi Görüntüle
                            </Button>
                        ) : null
                    }
                >
                    <InfoCircleOutlined style={{color: "#52c41a", fontSize: 28}} />
                    <div>
                        <div style={{fontWeight: 600, fontSize: 16}}>
                            Güncel Sözleşme POS Komisyonu
                        </div>
                        <div
                            style={{
                                fontSize: 18,
                                color: "#389e0d",
                                fontWeight: 700,
                                marginTop: 2
                            }}
                        >
                            {codCommissionRate != null ? `${codCommissionRate} %` : "-"}
                        </div>
                        <div style={{fontSize: 12, color: "#888"}}>Haftalık</div>
                    </div>
                </Card>
            )}
            <CodAggrementSelectionModal
                open={open}
                setOpen={setOpen}
                recall={recall}
                setRecall={setRecall}
                canCodPaymentMethodSelectionSubcompanies={canCodPaymentMethodSelectionSubcompanies}
            />
            <DocumentModal
                visibility={codContractModalVisibility}
                onCancel={() => setCodContractModalVisibility(false)}
                documentUrl={codContractUrl}
                title="Kapıda Ödeme Sözleşmesi"
                isNeedForApproval={false}
                description={
                    <p style={{fontSize: "20px", textAlign: "left", lineHeight: "1.8"}}>
                        Sözleşmenin bir kopyasını bir hafta içerisinde ıslak imzalı olarak Vigo
                        Merkez Ofise göndermelisiniz.
                    </p>
                }
            />
        </>
    );
};
